<app-header [translation]="myLanguage"></app-header>

<div class="container">
    <article>

        <h1 class="post-title mt-0">Together Platform</h1>
        
        <div *ngIf="togetherLoginDto === undefined && !this.error">
            Bitte warten ...
        </div>

        <div *ngIf="togetherLoginDto !== undefined">

            <div *ngIf="togetherLoginDto.status && togetherLoginDto.status === 200 && !togetherLoginDto.whitelisted && togetherLoginDto.message && togetherLoginDto.message === 'User already requested whitelisting'">
                <div class="mt-4">
                    <span class="info-box blue">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-hourglass-high"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6.5 7h11" /><path d="M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z" /><path d="M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z" /></svg>
                        <strong>Fehlende Zugangsberechtigung</strong>
                    </span>
                </div>
                <p class="mt-4">
                    Das Einloggen in Together ist derzeit noch nicht möglich, da die Erstellung deines Accounts beim erstmaligen Login bis zu 24 Stunden dauern kann.
                </p>
                <p>
                    Bitte beachte, dass die Account-Erstellung seitens Together ausschließlich an Werktagen erfolgt.
                </p>
                <p>
                    Wenn du dich am Wochenende oder an einem Feiertag anmeldest, beginnt die Bearbeitung erst am nächsten Werktag, und der Zugang wird anschließend erstellt.
                </p>
                <p>
                    Bitte versuche es daher erneut, sobald dieser Zeitraum verstrichen ist.
                </p>

                <button class="btn btn-primary btn-sm mt-4" (click)="launchTogetherCheck()">Einstieg erneut versuchen</button>
            </div>

            <div *ngIf="togetherLoginDto.status && togetherLoginDto.status === 200 && !togetherLoginDto.whitelisted && togetherLoginDto.message && togetherLoginDto.message === 'User requested whitelisting'">
                <div class="mt-4">
                    <span class="info-box blue">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-hourglass-high"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6.5 7h11" /><path d="M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z" /><path d="M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z" /></svg>
                        <strong>Fehlende Zugangsberechtigung</strong>
                    </span>
                </div>
                <p class="mt-4">
                    Das Einloggen in Together ist derzeit noch nicht möglich, da die Erstellung deines Accounts beim erstmaligen Login bis zu 24 Stunden dauern kann.
                </p>
                <p>
                    Bitte beachte, dass die Account-Erstellung seitens Together ausschließlich an Werktagen erfolgt.
                </p>
                <p>
                    Wenn du dich am Wochenende oder an einem Feiertag anmeldest, beginnt die Bearbeitung erst am nächsten Werktag, und der Zugang wird anschließend erstellt.
                </p>
                <p>
                    Bitte versuche es daher erneut, sobald dieser Zeitraum verstrichen ist.
                </p>
            </div>

            <div *ngIf="togetherLoginDto.status && togetherLoginDto.status === 200 && togetherLoginDto.whitelisted && togetherLoginDto.message && togetherLoginDto.message === 'User is whitelisted'">
                <div class="mt-4">
                    <span class="info-box green">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-hourglass-high"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6.5 7h11" /><path d="M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z" /><path d="M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z" /></svg>
                        <strong>Weiterleitung - Bitte warten ...</strong>
                    </span>

                    <p class="mt-4">
                        Sollte die automatische Weiterleitung nicht funktionieren, klicke <a href="https://www.servicebytogether.at/identity.server/account/login?loginScheme=oidc-efs&returnUrl=/hybridgui/start.jsf">hier</a>
                    </p>
                </div>
            </div>

        </div>

        <div *ngIf="error === 'failed_to_launch_together_login'">
            <div class="alert alert-danger">
                <strong>Fehler!</strong>
                <p class="mt-2 mb-0">
                    Deine Account-Daten konnten nicht mit dem Datenbestand von Together abgeglichen werden und daher ist ein Einstieg nicht möglich.<br>Bitte wenden dich an den EFS-IT-Support unter <a href="mailto:support&#64;efs-ag.com">support&#64;efs-ag.com</a>.
                </p>
            </div>
        </div>

    </article>
</div>

<app-footer [translation]="myLanguage" [userData]="userData"></app-footer>